export default __webpack_public_path__ + "static/media/nuvem.dcac1a01.svg";